<template lang="html">
  <div class="headerPanel row">
    <div class="profileContainer">
      <div class="profileImg"/>
      <span class="profileName">
        {{ username }}<br/>
      </span>
    </div>
    <div class="closePanel close-panel">
      <f7-icon class="imgClosePanel close-panel" :icon="isWhite()"></f7-icon>
    </div>
  </div>
</template>

<script>
import design from '@/design/design.json'

export default {
  name: 'MobileIdentityHeader',
  props: {
    username: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      design: design.menu
    }
  },
  methods: {
    isWhite () {
      if (this.design.headbandTextColor.length >= 7) {
        var c = this.design.headbandTextColor.substring(1)
        var rgb = parseInt(c, 16)
        var r = (rgb >> 16) & 0xff
        var g = (rgb >> 8) & 0xff
        var b = (rgb >> 0) & 0xff

        var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b

        if (luma < 40) {
          return 'icon-cross'
        } else {
          return 'icon-cross_white'
        }
      }
      return 'icon-cross'
    }
  }
}
</script>

<style lang="css" scoped>
.headerPanel {
  width: 100%;
  height: 10%;
  margin-left: 0;
  margin-bottom: auto;
}
.profileContainer {
  display: flex;
  width: 90%;
  height: 100%;
}
.profileImg {
  background-image: url('./../../../assets/static/images/image-profile.png');
  background-size: contain;
  background-repeat: no-repeat;
  width: 45px;
  height: 45px;
  border-radius:50%;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 5%;
}
.profileName {
  height: 100%;
  display: inline-flex;
  align-items: center;
  line-height: normal;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 5%;
  margin-right: auto;
  font-weight: bold;
  color: var(--headbandTextColor);
}
.closePanel {
  width: 10%;
  height: 100%;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
}
.imgClosePanel {
  width: 28px;
  height: 28px;
  margin-top:auto;
  margin-bottom:auto;
  float:right;
}

</style>



// WEBPACK FOOTER //
// MobileIdentityHeader.vue?1cfee828